<div>
  <div class="grid grid-cols-1 gap-6 md:grid-cols-2" [class.lg:grid-cols-3]="isHouse()">
    <!-- Habitable Surface -->
    <div class="flex flex-col gap-1">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
        <mat-label>Superficie habitable</mat-label>
        <input matInput type="number" [formField]="formTree.habitableSurface" placeholder="0" />
        <span matSuffix class="mr-1 text-sm font-medium text-neutral-11">m²</span>
        <button
          mat-icon-button
          matSuffix
          type="button"
          tabindex="-1"
          class="text-neutral-10 hover:text-neutral-12 mr-1 h-8 w-8 leading-8"
          matTooltip="Surface de plancher fermée, couverte et chauffée avec une hauteur sous plafond ≥ 1,80 m (Loi Carrez / Boutin). Exclut les combles non aménagés, caves, garages, terrasses et les parties < 1,80 m."
          matTooltipPosition="above"
        >
          <mat-icon class="text-lg">help_outline</mat-icon>
        </button>
        @if (formTree.habitableSurface().errors().length && formTree.habitableSurface().touched()) {
          <mat-error>La superficie habitable est requise (min 9 m²)</mat-error>
        }
      </mat-form-field>
      <div class="flex items-center justify-between gap-2 flex-wrap text-xs">
        <p class="text-neutral-11 m-0">Surface chauffée avec hauteur sous plafond ≥ 1,80 m</p>
        @if (pricePerSquareMeter(); as priceM2) {
          <span
            class="inline-flex items-center gap-1 font-semibold text-primary-9 bg-primary-2 px-2 py-0.5 rounded-md border border-primary-4"
          >
            <mat-icon class="text-xs! w-3.5! h-3.5!">payments</mat-icon>
            Prix indicatif : {{ priceM2 | number: '1.0-0' : 'fr-FR' }} €/m²
          </span>
        }
      </div>
    </div>

    <!-- Ground Surface (Superficie au sol) -->
    <div class="flex flex-col gap-1">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
        <mat-label>Superficie au sol</mat-label>
        <input matInput type="number" [formField]="formTree.groundSurface" placeholder="0" />
        <span matSuffix class="mr-1 text-sm font-medium text-neutral-11">m²</span>
        <button
          mat-icon-button
          matSuffix
          type="button"
          tabindex="-1"
          class="text-neutral-10 hover:text-neutral-12 mr-1 h-8 w-8 leading-8"
          matTooltip="Surface totale intérieure au sol, incluant les parties sous combles et sous-pentes avec une hauteur sous plafond < 1,80 m."
          matTooltipPosition="above"
        >
          <mat-icon class="text-lg">help_outline</mat-icon>
        </button>
        @if (formTree.groundSurface().errors().length && formTree.groundSurface().touched()) {
          <mat-error>
            La superficie au sol doit être supérieure ou égale à la superficie habitable
            @if (formTree.habitableSurface().value()) {
              (min {{ formTree.habitableSurface().value() }} m²)
            }
          </mat-error>
        }
      </mat-form-field>
      <p class="text-xs text-neutral-11">Inclut l'espace sous-pentes et combles (< 1,80 m).</p>
    </div>

    <!-- Land Surface (Superficie du terrain - Maison) -->
    @if (isHouse()) {
      <div class="flex flex-col gap-1.5">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
          <mat-label>Superficie du terrain</mat-label>
          <input matInput type="number" [formField]="formTree.landSurface" placeholder="0" />
          <span matSuffix class="mr-1 text-sm font-medium text-neutral-11">m²</span>
          <button
            mat-icon-button
            matSuffix
            type="button"
            tabindex="-1"
            class="text-neutral-10 hover:text-neutral-12 mr-1 h-8 w-8 leading-8"
            matTooltip="Assiette foncière globale rattachée à la maison (emprise bâtie, cour et jardin). Si le bien comprend plusieurs parcelles cadastrales, indiquez leur contenance cumulée ou la surface réelle issue d'un bornage."
            matTooltipPosition="above"
          >
            <mat-icon class="text-lg">help_outline</mat-icon>
          </button>
          @if (formTree.landSurface().errors().length && formTree.landSurface().touched()) {
            <mat-error>La superficie du terrain est requise pour une maison (min 1 m²)</mat-error>
          }
        </mat-form-field>

        <!-- Rappel de la surface cadastrale & informations d'aide -->
        <div class="flex flex-col gap-1 text-xs">
          @if (cadastralSurface(); as cadSurf) {
            <div class="flex items-center justify-between flex-wrap gap-2 pt-0.5">
              <span class="inline-flex items-center gap-1.5 text-neutral-11">
                <span
                  >Contenance cadastrale officielle :
                  <strong class="text-neutral-12 font-mono"
                    >{{ cadSurf | number: '1.0-0' : 'fr-FR' }} m²</strong
                  ></span
                >
              </span>

              @if (isLandSurfaceModifiedFromCadastre()) {
                <button
                  type="button"
                  class="text-2xs font-semibold text-primary-10 hover:text-primary-11 transition-colors cursor-pointer underline decoration-dotted"
                  (click)="resetToCadastralSurface()"
                  matTooltip="Rétablir la contenance officielle enregistrée au cadastre"
                >
                  Rétablir la surface cadastrale
                </button>
              }
            </div>
          }

          <div class="flex flex-col items-center gap-1.5 text-neutral-11">
            <span>Assiette foncière totale (bâti, cour et jardin).</span>
            <span
              class="cursor-help font-medium text-primary-10 underline decoration-dotted underline-offset-2 hover:text-primary-11"
              matTooltip="Pré-rempli automatiquement avec la contenance cadastrale validée à l'étape précédente. Vous pouvez modifier cette valeur si vous disposez d'un plan de bornage contradictoire de géomètre-expert ou en cas de division récente."
              matTooltipPosition="above"
            >
              Pourquoi modifier ?
            </span>
          </div>
        </div>
      </div>
    }
  </div>
</div>
